<p class="label-form">{{label}}</p>
<!-- Immer derselbe Abstand wie in app-input-text — sonst klebt der einzelne
     Wert an seinem Label, waehrend daneben ein Feld Luft hat. -->
<div class="spacer"></div>
<div class="input_result">
  <div class="input" [ngClass]="{'flat-bottom': dropdownOpen, 'single-result': values.length === 1}" (click)="dropdownOpen = !dropdownOpen">{{value.text}}
    <div class="input__icon"></div></div>
    @if (dropdownOpen) {
      <div class="input_result__result">
        @if (values.length) {
          <div class="input_result__result__inner"
            [@listAnimation]="values.length">
            @for (value of values; track value.id) {
              <div class="input_result__result__value" (click)="setValue(value)">
                {{value.text}}
                <app-svg-icon
                  class="icon"
                  [src]="'icons/24/arrow-right.svg'"
                  [svgStyle]="{ 'width.px': '24', 'height.px': '24' }"
                ></app-svg-icon>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  @if (invalid) {
    <p class="error">{{errorText}}</p>
  }

